<script type="text/javascript">
import FilterListTreeChild from './FilterListTreeChild';
    
//const EventBus = new Vue();
  export default {
        component:{
            FilterListTreeChild
        },
        name: 'FilterListTreeChild',
        props: {
            childs: Array,
            all_categories: Array,
            productcategories: Array,
            productid: Number,
            selectedcids: Array,
        }, 
        template: '',
         beforeMount(){
        /*axios.get('http://localhost:7080/gemesislabs-framework/public/seller/product/'+this.productid+'/categories').then(response => {
                 console.log(response);
               this.productcategories = response.data;
            })*/
            this.selectedchildids = [];
        },
        mounted(){
            let self = this;
            //self.selectedchildids = self.selectedcids;
            EventBus.$on('categories-cleared', function(){
               self.selectedchildids = [];
            })
            EventBus.$on('check-all-categories', function(){
                self.checkAll;
            })
        },
        data: function() {
        return{
            all_categories: [],
            childdata: this.childs,
            childitems: [],
            product_categories: this.productcategories,
            testObject: [],
            product_id: this.productid,
            showDropdown: 'show',
            selectedchildids: [],
        }
        },

        methods:{
            addToCategory(id){
                /*if(this.selectedchildids.length == 0){
                    this.selectedchildids[0] = id;
                }else{
                this.selectedchildids.push(id);
                }*/
                EventBus.$emit('category-added', id);     
            },
             findIds(id){
                this.testObject = [];
                this.testObject = this.selectedcids.filter(item => item == id);
                    if(this.testObject.length){
                        return "checked";
                    }else{
                        return false;
                    }

                },
        },
         computed: {
        checkAll: {
            get: function () {
                return this.all_categories ? this.selectedchildids.length == this.all_categories.length : false;
            },
            set: function (value) {
                var selected = [];
                if (value) {
                    this.all_categories.forEach(function (data) {
                        selected.push(data.id);
                        EventBus.$emit('category-added', data.id);
                    });
                }
                this.selectedchildids = selected;
            }
        },
        checkBoxes: function(){
            this.selectedchildids = this.selectedcids;
        }
    }
}
</script>
<template>
    <ul class="tree-child" v-bind:class="showDropdown"><li v-for="child in childs"><div class="custom-control custom-checkbox"><input type="checkbox" v-bind:value="child.id" v-on:click="addToCategory(child.id)" v-model="selectedchildids" class="custom-control-input" v-bind:id="child.id"><label class="custom-control-label" v-bind:for="child.id">{{child.name}}</label></div><ul v-for="categories in childs" v-if="categories.id === child.id"><FilterListTreeChild :childs="categories.childs" ></FilterListTreeChild></ul></li></ul>
</template>